module.exports = __webpack_public_path__ + "static/img/user3.495c925.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user3.png
// module id = CCfU
// module chunks = 1